import { render, staticRenderFns } from "./BookingKanban.vue?vue&type=template&id=3129ff16&scoped=true&"
import script from "./BookingKanban.vue?vue&type=script&lang=js&"
export * from "./BookingKanban.vue?vue&type=script&lang=js&"
import style0 from "./BookingKanban.vue?vue&type=style&index=0&id=3129ff16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3129ff16",
  null
  
)

export default component.exports